import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-92c4a1ea.js';
import { V as findElementInEventPath, U as stopImmediatePropagation, Q as stopEvent, i as isSSR, a0 as scrollToElement, ac as KeydownManager, ad as KeydownTemplate, a6 as FocusType, aa as KeydownLifecycleMethod, n as SCREEN_SIZE_GLOBAL_KEY, f as OWC_GLOBAL_KEY, S as SCREEN_GLOBAL_KEY, g as getDocument } from './p-a57042e3.js';
import { a as ComponentUtils, d as getScreenSize } from './p-de830ba7.js';
import { b as accessibility } from './p-756e7dc5.js';
import { O as OnElementMutation } from './p-7b2053f2.js';
const stepperCss = ".sc-owc-stepper-h{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:center;justify-content:center;padding:var(--one-spacing-padding-2-xs);outline:none}@media screen and (min-width: 0) and (max-width: 319px){.sc-owc-stepper-h{padding:var(--one-spacing-padding-none);-ms-flex-pack:start;justify-content:flex-start}}@media screen and (min-width: 320px) and (max-width: 719px){.sc-owc-stepper-h{padding:var(--one-spacing-padding-none);-ms-flex-pack:start;justify-content:flex-start}}.owc-stepper--direction-vertical.sc-owc-stepper-h{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start}@media screen and (min-width: 0) and (max-width: 319px){.owc-stepper--direction-vertical.sc-owc-stepper-h owc-step.sc-owc-stepper{height:100%;-ms-flex-negative:0;flex-shrink:0}}@media screen and (min-width: 320px) and (max-width: 719px){.owc-stepper--direction-vertical.sc-owc-stepper-h owc-step.sc-owc-stepper{height:100%;-ms-flex-negative:0;flex-shrink:0}}@media screen and (min-width: 0) and (max-width: 319px){.owc-stepper--direction-horizontal.sc-owc-stepper-h owc-step.sc-owc-stepper{-ms-flex-negative:0;flex-shrink:0;width:100%}}@media screen and (min-width: 320px) and (max-width: 719px){.owc-stepper--direction-horizontal.sc-owc-stepper-h owc-step.sc-owc-stepper{-ms-flex-negative:0;flex-shrink:0;width:100%}}.owc-stepper--direction-horizontal.sc-owc-stepper-h owc-step.sc-owc-stepper owc-divider.sc-owc-stepper{-webkit-transform:translate(calc(50% - calc(var(--one-spacing-size-s) / 2)));transform:translate(calc(50% - calc(var(--one-spacing-size-s) / 2)))}@media screen and (min-width: 0) and (max-width: 319px){.owc-stepper--direction-horizontal.sc-owc-stepper-h owc-step.sc-owc-stepper owc-divider.sc-owc-stepper{-webkit-transform:unset;transform:unset}}@media screen and (min-width: 320px) and (max-width: 719px){.owc-stepper--direction-horizontal.sc-owc-stepper-h owc-step.sc-owc-stepper owc-divider.sc-owc-stepper{-webkit-transform:unset;transform:unset}}.sc-owc-stepper-h owc-step.sc-owc-stepper:last-of-type owc-divider.sc-owc-stepper{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;-ms-flex-pack:start;justify-content:flex-start}@media screen and (min-width: 0) and (max-width: 319px){.sc-owc-stepper-h owc-step.sc-owc-stepper:last-of-type owc-divider.sc-owc-stepper{width:100%;-ms-flex-pack:center;justify-content:center}}@media screen and (min-width: 320px) and (max-width: 719px){.sc-owc-stepper-h owc-step.sc-owc-stepper:last-of-type owc-divider.sc-owc-stepper{width:100%;-ms-flex-pack:center;justify-content:center}}.sc-owc-stepper-h owc-step.sc-owc-stepper:last-of-type owc-divider.sc-owc-stepper::after{display:none}@media screen and (min-width: 0) and (max-width: 319px){.sc-owc-stepper-h owc-step.sc-owc-stepper:last-of-type owc-divider.sc-owc-stepper::after{display:block}}@media screen and (min-width: 320px) and (max-width: 719px){.sc-owc-stepper-h owc-step.sc-owc-stepper:last-of-type owc-divider.sc-owc-stepper::after{display:block}}";
const OwcStepperStyle0 = stepperCss;
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const STEP_TAG = 'OWC-STEP';
// eslint-disable-next-line no-shadow
var STATUS;
(function (STATUS) {
  STATUS["DEFAULT"] = "default";
  STATUS["COMPLETE"] = "complete";
  STATUS["IN_PROGRESS"] = "in-progress";
  STATUS["ALARM"] = "alarm";
})(STATUS || (STATUS = {}));
const Stepper = /*@__PURE__*/proxyCustomElement(class Stepper extends H {
  constructor() {
    super();
    this.__registerHost();
    this.activeStepChange = createEvent(this, "activeStepChange", 3);
    this.onStepClick = e => {
      const item = findElementInEventPath(e, STEP_TAG);
      if (item && !item.disabled && !item.linear) {
        const index = this.getItems().findIndex(el => item.isSameNode(el));
        this.setActiveStep(index);
        this.hostElement.focus();
        this.component.keydownManager().setCurrentItem(this.getItems()[index], {
          scrollBehavior: 'top',
          event: e
        }, false);
      }
    };
    this.setActiveStep = newIndex => {
      if (newIndex !== this.activeStep) {
        if (!this.controlled) {
          this.activeStep = newIndex;
        } else {
          this.activeStepChange.emit(newIndex);
        }
      }
    };
    this.handleMouseDown = e => {
      const item = findElementInEventPath(e, STEP_TAG);
      if (!item) {
        stopImmediatePropagation(e);
        stopEvent(e);
      }
    };
    this.getItems = () => Array.from(this.hostElement.querySelectorAll(STEP_TAG.toLowerCase()));
    this.getSelectableItems = () => this.getItems().filter(item => !item.disabled);
    this.updateDirection = inputScreenSize => {
      var _a;
      if (isSSR()) {
        return;
      }
      const screenSize = inputScreenSize || this.getScreenSize();
      if (screenSize === 'xs' || screenSize === 'sm') {
        this.stepDirection = 'horizontal';
        this.overflow = 'hidden';
        (_a = this.getItems()[this.activeStep]) === null || _a === void 0 ? void 0 : _a.scrollIntoView(false);
      } else {
        this.stepDirection = this.direction;
        this.overflow = 'overlay';
      }
    };
    this.propagateAttributesToItems = () => {
      this.getItems().forEach((item, index) => {
        var _a;
        item.direction = this.stepDirection;
        if (this.activeStep === index) {
          this.lastActiveIndex = index;
          this.lastActiveStatus = item.status;
          item.status = STATUS.IN_PROGRESS;
          scrollToElement(item, this.hostElement, this.stepDirection === 'horizontal' ? 'right' : 'top', undefined, this.overflow);
        }
        item.linear = this.linear;
        item.step = (_a = item.step) !== null && _a !== void 0 ? _a : index + 1;
        item.tabIndex = -1;
        item.dividerProps = Object.assign(Object.assign({}, item.dividerProps || {}), {
          captionPosition: 'start'
        });
      });
    };
    this.component = new ComponentUtils(this).withKeydownManager([KeydownManager.Templates[KeydownTemplate.GROUP], {
      focusType: FocusType.BY_CLASS,
      selector: () => this.getSelectableItems(),
      actualSelectedItem: () => this.getItems()[this.activeStep || 0],
      lifecycleHandlers: {
        [KeydownLifecycleMethod.ITEM_CHANGE]: ({
          items,
          current
        }) => {
          var _a;
          this.activeStepId = ((_a = items[current]) === null || _a === void 0 ? void 0 : _a.id) || undefined;
        }
      }
    }]);
    this.direction = 'horizontal';
    this.linear = false;
    this.controlled = false;
    this.activeStep = 0;
    this.activeStepId = undefined;
    this.stepDirection = undefined;
    this.overflow = undefined;
  }
  onActiveStepChange(nextValue, prevValue) {
    if (prevValue !== nextValue && nextValue >= 0 && nextValue < this.getItems().length) {
      !this.controlled && this.activeStepChange.emit(this.activeStep);
      const lastClickedItem = this.getItems()[this.lastActiveIndex];
      lastClickedItem && (lastClickedItem.status = this.lastActiveStatus || STATUS.DEFAULT);
    }
  }
  onContentChange() {
    this.propagateAttributesToItems();
  }
  onDocumentResized(e) {
    const screenSize = this.getScreenSize(e.detail[SCREEN_SIZE_GLOBAL_KEY]);
    if (this.storedScreenSize !== screenSize) {
      this.storedScreenSize = screenSize;
      this.updateDirection(screenSize);
    }
  }
  componentDidLoad() {
    var _a;
    this.updateDirection();
    this.activeStepId = (_a = this.getSelectableItems()[this.activeStep]) === null || _a === void 0 ? void 0 : _a.id;
    this.propagateAttributesToItems();
  }
  componentWillRender() {
    this.updateDirection();
    this.propagateAttributesToItems();
  }
  getScreenSize(inputScreenSize) {
    var _a, _b, _c, _d, _e;
    return inputScreenSize || ((_b = (_a = window[OWC_GLOBAL_KEY]) === null || _a === void 0 ? void 0 : _a[SCREEN_GLOBAL_KEY]) === null || _b === void 0 ? void 0 : _b[SCREEN_SIZE_GLOBAL_KEY]) || getScreenSize((_e = (_d = (_c = getDocument()) === null || _c === void 0 ? void 0 : _c.documentElement) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect()) === null || _e === void 0 ? void 0 : _e.width);
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      linear: this.linear,
      [`direction-${this.stepDirection || 'horizontal'}`]: true
    });
    return h(Host, Object.assign({
      key: '77562ff1061779a3e2fcdd449b88a696f8944ac6',
      class: hostClasses,
      tabIndex: this.linear ? -1 : this.component.getInitialTabIndex(0),
      onMouseDown: this.handleMouseDown,
      onClick: this.onStepClick
    }, accessibility({
      role: 'tablist',
      aria: {
        activedescendant: this.activeStepId
      }
    })), h("slot", {
      key: '744e74c0195d6a59e595905150a52e7b05049166'
    }));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "activeStep": ["onActiveStepChange"]
    };
  }
  static get style() {
    return OwcStepperStyle0;
  }
}, [6, "owc-stepper", {
  "direction": [513],
  "linear": [516],
  "controlled": [516],
  "activeStep": [1538, "active-step"],
  "activeStepId": [32],
  "stepDirection": [32],
  "overflow": [32]
}, [[4, "documentResized", "onDocumentResized"]], {
  "activeStep": ["onActiveStepChange"]
}]);
__decorate([OnElementMutation({
  target: self => self.hostElement,
  childList: true,
  attributes: true
})], Stepper.prototype, "onContentChange", null);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-stepper"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-stepper":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Stepper);
        }
        break;
    }
  });
}
const OwcStepper = Stepper;
const defineCustomElement = defineCustomElement$1;
export { OwcStepper, defineCustomElement };